export default __webpack_public_path__ + "assets/icons/queryWaybill.adbda497.svg";